import React from "react";

/**
 * Shared button primitive. Replaces the inline `<button className="...">`
 * strings scattered across pages (Navbar, LandingPage, register flow ...).
 *
 * variant: "primary" | "secondary" | "ghost"
 * size:    "sm" | "md" | "lg"
 */
const base =
  "inline-flex items-center justify-center font-medium rounded-lg border border-transparent shadow-sm transition duration-150 active:translate-y-px focus:outline-none focus:ring-2 focus:ring-fairblue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none disabled:active:translate-y-0";

const variants = {
  // green hero actions
  primary:
    "text-fairblack bg-fairdarkgreen hover:bg-fairblue-500 hover:text-fairwhite",
  secondary:
    "text-fairblack bg-fairbrightgreen hover:bg-fairblue-500 hover:text-fairwhite",
  // blue submit / call-to-action (register, apply, try ...)
  cta: "text-white bg-fairblue-500 hover:bg-fairdarkgreen hover:text-black",
  // white outline, sits on coloured backgrounds
  outline:
    "text-fairblue-500 bg-white border-fairblue-500 hover:bg-fairgray",
  ghost: "text-fairblue-500 bg-transparent shadow-none hover:bg-fairgray",
};

const sizes = {
  sm: "px-3 py-2 text-sm",
  md: "px-4 py-2 text-base",
  lg: "px-8 py-3 text-base md:py-4 md:text-lg md:px-10",
};

function Button({
  variant = "primary",
  size = "md",
  type = "button",
  fullWidth = false,
  className = "",
  children,
  ...rest
}) {
  return (
    <button
      type={type}
      className={`${base} ${variants[variant] ?? variants.primary} ${
        sizes[size] ?? sizes.md
      } ${fullWidth ? "w-full" : ""} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}

export default Button;
